webpackJsonp([70144966829960],{

/***/ 112:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.SinglePreventCloseAccordion = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(10);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Accordion = __webpack_require__(57);
	
	var _Accordion2 = _interopRequireDefault(_Accordion);
	
	var _shared = __webpack_require__(58);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var SinglePreventCloseAccordion = function SinglePreventCloseAccordion(_ref) {
	  var items = _ref.items,
	      topLine = _ref.topLine,
	      small = _ref.small,
	      props = _objectWithoutProperties(_ref, ['items', 'topLine', 'small']);
	
	  return _react2.default.createElement(
	    _Accordion2.default,
	    _extends({ stateReducer: _shared.single }, props),
	    function (_ref2) {
	      var openIndexes = _ref2.openIndexes,
	          handleItemClick = _ref2.handleItemClick;
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('c-accordion', {
	            'c-accordion--top-line': topLine,
	            'c-accordion--small': small
	          })
	        },
	        items.map(function (item, index) {
	          return _react2.default.createElement(
	            'div',
	            {
	              key: item.title,
	              className: (0, _classnames2.default)('c-accordion__item', {
	                'is-open': openIndexes.indexOf(index) >= 0
	              })
	            },
	            _react2.default.createElement(
	              'div',
	              {
	                className: 'c-accordion__btn t-h2',
	                onClick: function onClick() {
	                  return handleItemClick(index);
	                }
	              },
	              item.title
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'c-accordion__contents' },
	              item.contents
	            )
	          );
	        })
	      );
	    }
	  );
	};
	
	exports.SinglePreventCloseAccordion = SinglePreventCloseAccordion;

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.SinglePreventCloseAccordion = undefined;
	
	var _SinglePreventCloseAccordion = __webpack_require__(75);
	
	Object.defineProperty(exports, 'SinglePreventCloseAccordion', {
	  enumerable: true,
	  get: function get() {
	    return _SinglePreventCloseAccordion.SinglePreventCloseAccordion;
	  }
	});
	
	__webpack_require__(112);

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(8);
	
	__webpack_require__(7);
	
	var _reactLoadingOverlay = __webpack_require__(30);
	
	var _reactLoadingOverlay2 = _interopRequireDefault(_reactLoadingOverlay);
	
	var _Accordion = __webpack_require__(76);
	
	var _contactLocations = __webpack_require__(81);
	
	var _contactLocations2 = _interopRequireDefault(_contactLocations);
	
	__webpack_require__(70);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactForm = function (_React$Component) {
	  _inherits(ContactForm, _React$Component);
	
	  function ContactForm() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ContactForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      firstname: "",
	      lastname: "",
	      email: "",
	      tel: "",
	      company: "",
	      message: "",
	      success: false,
	      overlayText: "Sending...",
	      overlaySpinner: true,
	      source: _this.props.source
	    }, _this.handleUpdate = function (event) {
	      var _this$setState;
	
	      _this.setState((_this$setState = {}, _this$setState[event.target.name] = event.target.value, _this$setState));
	    }, _this.handleSubmit = function (event) {
	      event.preventDefault();
	      {
	        document.getElementById("contact-form-fs").disabled = true;
	      };
	      {
	        document.getElementById("sendbtn").disabled = true;
	      };
	      {
	        document.getElementById("sendbtn").setAttribute("style", "background: #cd626d");
	      };
	      _this.setState({
	        isActive: true,
	        overlayText: "Sending...",
	        overlaySpinner: true
	      });
	      //alert(JSON.stringify(this.state));
	
	      _this.postData("/email/postEmailer.php") //.then(data => console.log(JSON.stringify(data)))
	
	      .then(function (data) {
	        _this.setState({
	          overlayText: "Sent!",
	          overlaySpinner: false
	        });
	      });
	
	      setTimeout(function () {
	        _this.setState({ isActive: false });
	        document.getElementById("contact-form").reset();
	        document.getElementById("contact-form-fs").disabled = false;
	        document.getElementById("sendbtn").disabled = false;
	        {
	          document.getElementById("sendbtn").setAttribute("style", "");
	        };
	      }, 3000);
	    }, _this.postData = function (url) {
	      // Default options are marked with *
	      return fetch(url, {
	        method: "POST", // *GET, POST, PUT, DELETE, etc.
	        mode: "cors", // no-cors, cors, *same-origin
	        //cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
	        //credentials: "same-origin", // include, *same-origin, omit
	        headers: {
	          "Content-Type": "application/x-www-form-urlencoded"
	
	          //"Content-Type": "text/html",
	          //"Accept" : "text/html"//,
	          //  "Accept-Encoding": "gzip, deflate"
	          // "Content-Type": "application/x-www-form-urlencoded",
	        },
	        body: "firstName=" + _this.state.firstname + "&lastName=" + _this.state.lastname + "&email=" + _this.state.email + "&tel=" + _this.state.tel + "&company=" + _this.state.company + "&message=" + _this.state.message
	      }).then(function (response) {
	        return response.text();
	      }); //.json()); // parses response to JSON
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ContactForm.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      "div",
	      { className: "contact-form-section__content o-column-container" },
	      _react2.default.createElement(
	        "div",
	        { className: "contact-form-section__left" },
	        _react2.default.createElement(
	          "h2",
	          { className: "contact-form-section__title t-h1" },
	          "Contact Us"
	        ),
	        _react2.default.createElement(_Accordion.SinglePreventCloseAccordion, { items: _contactLocations2.default })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "contact-form-section__right" },
	        _react2.default.createElement(
	          "h2",
	          { className: "contact-form-section__title t-h1" },
	          "Say Hello"
	        ),
	        _react2.default.createElement(
	          "form",
	          {
	            id: "contact-form",
	            className: "contact-form-section__form",
	            onSubmit: function onSubmit(event) {
	              _this2.handleSubmit(event);
	            },
	            onChange: function onChange(event) {
	              _this2.handleUpdate(event);
	            }
	          },
	          _react2.default.createElement(
	            "fieldset",
	            { id: "contact-form-fs", className: "contact-form-section__fieldset" },
	            _react2.default.createElement("input", {
	              id: "firstname",
	              name: "firstname",
	              type: "text",
	              placeholder: "*First Name",
	              required: true,
	              className: "contact-form-section__field contact-form-section__field--50 c-input"
	            }),
	            _react2.default.createElement("input", {
	              id: "lastname",
	              name: "lastname",
	              type: "text",
	              placeholder: "*Last Name",
	              required: true,
	              className: "contact-form-section__field contact-form-section__field--50 c-input"
	            }),
	            _react2.default.createElement("input", {
	              id: "email",
	              name: "email",
	              type: "email",
	              placeholder: "*Email Address",
	              required: true,
	              className: "contact-form-section__field contact-form-section__field--50 c-input"
	            }),
	            _react2.default.createElement("input", {
	              id: "tel",
	              name: "tel",
	              type: "tel",
	              placeholder: "Phone Number",
	              className: "contact-form-section__field contact-form-section__field--50 c-input"
	            }),
	            _react2.default.createElement("input", {
	              id: "company",
	              name: "company",
	              type: "text",
	              placeholder: "Company (if applicable)",
	              className: "contact-form-section__field contact-form-section__field--100 c-input"
	            }),
	            _react2.default.createElement("textarea", {
	              id: "message",
	              name: "message",
	              placeholder: "*Your Message\u2026",
	              required: true,
	              className: "contact-form-section__field contact-form-section__field--100 contact-form-section__textarea c-input"
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "contact-form-section__field" },
	            _react2.default.createElement(
	              _reactLoadingOverlay2.default,
	              {
	                active: this.state.isActive,
	                spinner: false,
	                text: this.state.overlayText,
	                classNamePrefix: this.state.source,
	                styles: {
	                  overlay: function overlay(base) {
	                    return _extends({}, base, {
	                      background: 'rgba(0, 0, 0, 0)'
	                    });
	                  }
	                }
	              },
	              _react2.default.createElement(
	                "button",
	                { id: "sendbtn", type: "submit", className: "c-btn t-link" },
	                "Send Message"
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return ContactForm;
	}(_react2.default.Component);
	
	exports.default = ContactForm;
	module.exports = exports["default"];

/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{
	  title: 'Los Angeles',
	  contents: _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'p',
	      { className: 't-h3' },
	      'Corporate Headquarters'
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 't-p mt10' },
	      'AmericanTours International, LLC. L.A. International Airport',
	      _react2.default.createElement('br', null),
	      ' ',
	      '6033 W Century Blvd, STE 900, Los Angeles, CA 90045'
	    ),
	    _react2.default.createElement(
	      'ul',
	      { className: 'mt10' },
	      _react2.default.createElement(
	        'li',
	        null,
	        'Phone: (310) 641-9953'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Fax: (310) 216-5807'
	      )
	    )
	  )
	}, {
	  title: 'Orlando',
	  contents: _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'p',
	      { className: 't-p mt10' },
	      'AmericanTours International, LLC.',
	      _react2.default.createElement('br', null),
	      ' ',
	      '5787 Vineland Road #207, Orlando, FL 32819'
	    ),
	    _react2.default.createElement(
	      'ul',
	      { className: 'mt10' },
	      _react2.default.createElement(
	        'li',
	        null,
	        'Phone: (407) 370-3701'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Fax: (407) 370-6928'
	      )
	    )
	  )
	}, {
	  title: 'New York',
	  contents: _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'p',
	      { className: 't-p mt10' },
	      'AmericanTours International, LLC. The New Yorker Hotel',
	      _react2.default.createElement('br', null),
	      ' ',
	      '481 Eighth Avenue Suite 605, New York, NY 10001'
	    ),
	    _react2.default.createElement(
	      'ul',
	      { className: 'mt10' },
	      _react2.default.createElement(
	        'li',
	        null,
	        'Phone: (212) 586-4100'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Fax: (212) 586-2225'
	      )
	    )
	  )
	}, {
	  title: 'Honolulu',
	  contents: _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'p',
	      { className: 't-p mt10' },
	      'AmericanTours International, LLC. Galleria Waikiki Office Tower',
	      _react2.default.createElement('br', null),
	      ' ',
	      '2222 Kalakaua Ave, Suite 1007, Honolulu, HI 96815'
	    ),
	    _react2.default.createElement(
	      'ul',
	      { className: 'mt10' },
	      _react2.default.createElement(
	        'li',
	        null,
	        'Phone: (808) 922-2841'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Fax: (808) 924-8486'
	      )
	    )
	  )
	}];
	module.exports = exports['default'];

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/contact__hero.3db1bb4e.jpg";

/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(5);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Header = __webpack_require__(6);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _contact__hero = __webpack_require__(490);
	
	var _contact__hero2 = _interopRequireDefault(_contact__hero);
	
	__webpack_require__(380);
	
	var _ContactForm = __webpack_require__(79);
	
	var _ContactForm2 = _interopRequireDefault(_ContactForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Page = function Page() {
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Contact'
	      // meta={[{ name: 'description', content: '' }]}
	    }),
	    _react2.default.createElement(
	      _Header2.default,
	      { hero: _contact__hero2.default },
	      _react2.default.createElement(
	        'h1',
	        { className: 't-hero' },
	        'Contact'
	      )
	    ),
	    _react2.default.createElement(
	      'main',
	      { id: 'content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'c-golden t-context--light' },
	        _react2.default.createElement(
	          'div',
	          { className: 'c-golden__content' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'c-breadcrumbs mb30' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/' },
	                'Home'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/contact', activeClassName: 'is-active' },
	                'Contact'
	              )
	            )
	          ),
	          _react2.default.createElement(_ContactForm2.default, { source: 'contact' })
	        )
	      )
	    )
	  );
	};
	
	exports.default = Page;
	module.exports = exports['default'];

/***/ }),

/***/ 380:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-4401bfc5eaa55a2d2c95.js